var _ref2, _ref3, _ref4, _ref5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStudy = function SvgStudy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7845 5.28163C11.9251 5.23946 12.0749 5.23946 12.2155 5.28163L22.2155 8.28163C22.5327 8.3768 22.75 8.66879 22.75 9V11C22.75 11.3312 22.5327 11.6232 22.2155 11.7184L12.2155 14.7184C12.0749 14.7605 11.9251 14.7605 11.7845 14.7184L1.78449 11.7184C1.46725 11.6232 1.25 11.3312 1.25 11V9C1.25 8.66879 1.46725 8.3768 1.78449 8.28163L11.7845 5.28163ZM2.75 9.55802V10.442L12 13.217L21.25 10.442V9.55802L12 6.78302L2.75 9.55802Z",
      fill: "#041F47"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.25 16.3333V13H7.75V15.7928L12 17.2094L16.25 15.7928V13H17.75V16.3333C17.75 16.6562 17.5434 16.9428 17.2372 17.0448L12.2372 18.7115C12.0832 18.7628 11.9168 18.7628 11.7628 18.7115L6.76283 17.0448C6.45657 16.9428 6.25 16.6562 6.25 16.3333Z",
      fill: "#041F47"
    })), _ref4 || (_ref4 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 11C20.5523 11 21 11.4477 21 12L21 17C21 17.5523 20.5523 18 20 18C19.4477 18 19 17.5523 19 17L19 12C19 11.4477 19.4477 11 20 11Z",
      fill: "#041F47"
    })), _ref5 || (_ref5 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2843 8.77649C11.4079 8.38114 11.8285 8.16079 12.2239 8.28434L20.2239 10.7843C20.6193 10.9079 20.8396 11.3285 20.7161 11.7239C20.5925 12.1193 20.1719 12.3396 19.7765 12.2161L11.7765 9.71606C11.3811 9.59251 11.1608 9.17185 11.2843 8.77649Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgStudy, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/study.79118a12.svg";
export { ForwardRef as ReactComponent };